var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{class:'user-guide-button ' + [_vm.inTitle ? 'mt-0 mb-1' : ''],attrs:{"slot":"activator","href":_vm.link,"icon":"","target":"_blank"},slot:"activator"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("help")])],1),_c('span',[_vm._v("Click to open the relevant section of the user guide")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }